import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import {getFacilityUsers} from "../services/FacilityService";
import {useLogout} from "./useLogout";

export function useFacilityUsers(facilityId) {
    const logout = useLogout();
    const {data, isError, error, isLoading, refetch} = useQuery({
        queryKey: ["facilityUsers", facilityId],
        queryFn: () => getFacilityUsers(facilityId),
        enabled: !!facilityId,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error, logout]);

    return {users: data, isLoading, isError, error, refetch};
}
